module.exports = __webpack_public_path__ + "static/media/bbc-news.72fa6d39.jpg";